// Port of api/fuel/app/classes/insights/games/compare.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

function uniqueSortedCounts(rows) {
	var index = {}
	for (var i = 0; i < rows.length; i++) {
		var value = parseInt(rows[i].v, 10) || 0
		if (value > 0) index[value] = value
	}
	return Object.keys(index).map(function(key) {
		return parseInt(key, 10)
	}).sort(function(a, b) {
		return a - b
	})
}

function buildHistogram(sizes, self) {
	var bucketCount = 25
	var position = 0
	var max = Math.max.apply(Math, sizes)
	var nonZero = sizes.filter(function(v) { return v > 0 })
	var min = Math.min.apply(Math, nonZero)
	var logMin = Math.log10(min)
	var logMax = Math.log10(max)
	var bucketSize = (logMax - logMin) / bucketCount
	var histogram = new Array(bucketCount).fill(0)
	var labels = []

	for (var i = 0; i < bucketCount; i++) {
		var bucketMin = Math.round(Math.pow(10, logMin + (bucketSize * i)))
		var bucketMax = Math.round(Math.pow(10, logMin + (bucketSize * (i + 1))))

		for (var s = 0; s < sizes.length; s++) {
			if (sizes[s] >= bucketMin && sizes[s] < bucketMax) histogram[i]++
		}

		var bucketMaxLabel = bucketMax - 1
		labels[i] = (bucketMin !== bucketMaxLabel)
			? (bucketMin + '-' + bucketMaxLabel + ' games')
			: (bucketMin + ' game' + (bucketMin > 1 ? 's' : ''))

		if (self >= bucketMin && self <= bucketMaxLabel) position = i
	}

	return { position: position, labels: labels, data: histogram }
}

export default Segment.extend({
	name: 'compare',
	priority: 2,
	types: [Constants.TYPE_USER],
	requires: ['init'],
	run: function(type, owner) {
		var gameIndex = this._data.game_index || []
		var userCount = gameIndex.length
		if (!userCount) return { compare: [] }

		var field = 'user_count_collection'
		var sizes = uniqueSortedCounts(Util.queryFast(
			'SELECT ' + field + ' AS v FROM user WHERE ' + field + ' > 0 ORDER BY ' + field + ' ASC'
		))

		if (!sizes.length) return { compare: [] }

		var self = owner.get_count_collection()

		return {
			compare: {
				histogram: buildHistogram(sizes, self),
				metrics: {
					percentile: Util.percentile(sizes, self),
					median: self - Util.median(sizes),
					total: self
				}
			}
		}
	}
})
